export const globalFilterFormatter = {
    formatGlobalFilter
};

function formatGlobalFilter(data) {
    return ( data && data.entities ) ? data.entities : [];
}